import wpLinkResolver from '@/wp-link-resolver'

// resp img settings
const sizes = [320, 480, 640, 800, 1024, 1280, 1440, 1600, 1920, 2400, 2880, 3600, 4096, 5120]
const dpx = window.devicePixelRatio || 1

export function proxyWPURL (url = '') {
  return url.replace(/(http|https)(:\/\/cms\.ottolinger\.com\/)/g, '/')
}

export function linkResolver (href) {
  return wpLinkResolver(href)
}

export function isRelLink (url) {
  return !url ? undefined : url.indexOf('http://') !== 0 && url.indexOf('https://') !== 0
}

export function isExtLink (url) {
  let wpBase = process.env.VUE_APP_WP_BASE_URL
  if (!wpBase) console.warn('Missing .env variable: VUE_APP_WP_BASE_URL')
  if (isRelLink(url)) return false
  url = new URL(url)
  wpBase = new URL(wpBase)
  return url.host !== wpBase.host
}

export function cloudinaryThumbSrc (src, l, useHt, format = 'jpg') {
  if (!src || src.includes('ottolinger-wp.test')) return src
  const baseUrl = process.env.VUE_APP_CLOUDINARY
  let params = ''
  if (l) {
    l = parseInt(dpx * l)
    // find best size
    let size = sizes.find(size => l <= size) || sizes[sizes.length - 1]
    size = useHt ? 'h_' + size : 'w_' + size
    params = `${size},f_${format}/`
  }
  return `${baseUrl}/image/fetch/${params}${src}`
}

export function shopifyThumbSrc (src, l, useHt) {
  // adjust for pixel density
  l = parseInt(dpx * l)
  // find best size
  const best = sizes.find(size => l <= size) || sizes[sizes.length - 1]
  // shopify resize param
  const resize = useHt ? `_x${best}` : `_${best}x`
  // replace extension
  return src.replace(/\.(jpg|png|gif|webm)\b/i, resize + '.$1')
}

export function formatPrice (price) {
  price = Number.isInteger(Number(price)) ? parseInt(price) : price
  return '€' + price
}

export function isSoldOut (variant) {
  return (variant && !variant.available)
  // if (!variant) return undefined
  // !variant.inventory_quantity && variant.inventory_policy === 'deny'
}

export function sortByKey (arr, dir = 'asc', key, log = false) {
  return arr.sort((a, b) => {
    a = key ? a[key] : a
    b = key ? b[key] : b
    const v1 = dir === 'asc' ? -1 : 1
    const v2 = dir === 'asc' ? 1 : -1
    return a < b ? v1 : a > b ? v2 : 0
  })
}

export function getDefaultVariant (product) {
  // find cheapest, for-sale variant (if exists)
  const variants = product.variants || []
  let forSale = variants.filter(vrnt => !isSoldOut(vrnt)) // .sort(sortByLowestPrice)
  forSale = sortByKey(forSale, 'asc', 'price')
  return forSale[0] || variants[0]
}

export function getFilename (path) {
  return (path && path.split('/').slice(-1)[0]) || ''
}

export function exception (msg, fatal = false) {
  /* track errors in google analytics */
  // console.error('track exception:', msg)
  return window.ga && window.ga('send', 'exception', { 'exDescription': msg, 'exFatal': fatal })
}
